import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class TrainingsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      current: '',
      next: '',
      previous: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.CertificationsTypesTable = this.CertificationsTypesTable.bind(this);
    this.PresenceTypesTable = this.PresenceTypesTable.bind(this);
    this.loadData = this.loadData.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      var now = new Date();
      var reference = now.getFullYear();
      this.setState({loaded: 2}, this.loadData(reference));
    }
  }

  loadData(reference) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamentos/' + reference, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var url = '/treinamento/editar/' + cell;
    
    var button = (
      <div className="btn-group">
        <Link className={'btn btn-primary btn-sm'} to={url}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>
      </div>
    );
    return button;
  }

  CertificationsTypesTable (cell, row) {
    var types = (
      <div>
        {Object.keys(cell).map(function(k) {
          return  <span><span className="label label-default">{cell[k]}</span> </span>
        })}
      </div>
    );

    return types;
  }
  PresenceTypesTable (cell, row) {
    var types = (
      <div>
        {Object.keys(cell).map(function(k) {
          return  <span><span className="label label-default">{cell[k]}</span> </span>
        })}
      </div>
    );

    return types;
  }


  next() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.next);
  }

  previous() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.previous);
  }
  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <div className="row">
        <div className="col-md-4">
          <button className="btn btn-primary" onClick={this.previous}><i className="fa fa-fw fa-chevron-left"></i> {this.state.previous}</button>
        </div>
        <div className="col-md-4">
          <h3 className="page-title text-center">{this.state.current}</h3>
        </div>
        <div className="col-md-4 text-right">
          <button className="btn btn-primary" onClick={this.next}>{this.state.next} <i className="fa fa-fw fa-chevron-right"></i></button>
        </div>
      </div>
      <hr/>
      <h3 className="page-title pull-left">{this.locale.Treinamentos.ListaDeTreinamentos.titulo}</h3>
      <Link to="/treinamento/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> {this.locale.Treinamentos.ListaDeTreinamentos.botaoAdicionarTreinamento}</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Treinamentos.ListaDeTreinamentos.tabela.semTreinamentos, defaultSortName: 'id', defaultSortOrder: 'desc', sizePerPage: 100, sizePerPageList: [{text: '10', value: 10}, {text: '25', value: 25}, {text: '50', value: 50}, {text: '100', value: 100}]}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Treinamentos.ListaDeTreinamentos.tabela.ID}</TableHeaderColumn>

        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='500'>{this.locale.Treinamentos.ListaDeTreinamentos.tabela.Nome}</TableHeaderColumn>

        <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Treinamentos.ListaDeTreinamentos.tabela.Status}</TableHeaderColumn>

        <TableHeaderColumn dataField="code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Treinamentos.ListaDeTreinamentos.tabela.CodigoDeControle}</TableHeaderColumn>


        <TableHeaderColumn dataField="certification_types" dataAlign="center" filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} dataFormat={this.CertificationsTypesTable} width='120'>{this.locale.Treinamentos.ListaDeTreinamentos.tabela.TiposDeCertificado}</TableHeaderColumn>

        <TableHeaderColumn dataField="presence_types" dataAlign="center" filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} dataFormat={this.PresenceTypesTable}>{this.locale.Treinamentos.ListaDeTreinamentos.tabela.Modalidade}</TableHeaderColumn>

        <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Treinamentos.ListaDeTreinamentos.tabela.DataInicial}</TableHeaderColumn>

        <TableHeaderColumn dataField="date_finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Treinamentos.ListaDeTreinamentos.tabela.DataFinal}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='120'>{this.locale.Treinamentos.ListaDeTreinamentos.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default TrainingsIndex;



// WEBPACK FOOTER //
// ./src/Components/Trainings/TrainingsIndex.js